/*
 *  Developed by CQ Inversiones SAS. Copyright (c) 2024. All rights reserved.
 *  Desarrollado por CQ Inversiones SAS. Copyright (c) 2024. Todos los derechos reservados.
 */

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez
 * Date:         30/04/24 - 09:54:30
 * Module name:  headers-groups-table.const
 * File name:    headers-groups-table.const.ts
 * IDE:          WebStorm
 */

import {TableColumnAlignEnum, TableColumnEnum, TableColumnInterface, TableIconEnum} from '@shared/components/table';

/**
 * @description
 * Array of string keys for tooltips of various contact characteristics
 */
export const CONTACTS_FEATURES_TOOLTIPS: string[] = [
  'app.setting.contact.list.extra.feature.whatsapp',
  'app.setting.contact.list.extra.feature.telegram',
  'app.setting.contact.list.extra.feature.sms',
  'app.setting.contact.list.extra.feature.sendEmail'
];

/**
 * @description
 * Column array for contacts table
 */
export const CONTACTS_HEADERS: TableColumnInterface[] = [
  {
    field: 'name',
    type: TableColumnEnum.text,
    header: 'app.setting.contact.fields.name.label',
    align: TableColumnAlignEnum.center,
    sort: true,
  },
  {
    field: 'mobile',
    type: TableColumnEnum.phone,
    header: 'app.setting.contact.fields.numberPhone.label',
    align: TableColumnAlignEnum.center,
  },
  {
    field: 'email',
    type: TableColumnEnum.text,
    header: 'app.setting.contact.fields.email.label',
    align: TableColumnAlignEnum.center,
  },
  {
    field: 'enabled',
    type: TableColumnEnum.tag,
    header: 'app.setting.contact.fields.status.header',
    align: TableColumnAlignEnum.center,
  },
  {
    field: 'whatsapp',
    type: TableColumnEnum.iconGroup,
    header: 'app.setting.contact.fields.feature.label',
    align: TableColumnAlignEnum.center,
    groupIcon: [TableIconEnum.whatsapp, TableIconEnum.telegram, TableIconEnum.sms, TableIconEnum.mail],
    groupIconFields: ['whatsapp', 'telegram', 'sms', 'send_email'],
    groupIconTooltips: CONTACTS_FEATURES_TOOLTIPS,
  },
];
